// extracted by mini-css-extract-plugin
export var action = "landing-deck-module--action--7fe43";
export var container = "landing-deck-module--container--45b42";
export var main = "landing-deck-module--main--3361f";